import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/entitlement/importer/entitlementImporterActions';

export default importerReducers(actions);
